var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.appKey,style:({
    '--font': _vm.font,
    '--main-color': _vm.colors.mainColor,
    '--secondary-color': _vm.colors.secondaryColor,
    '--text-color': _vm.colors.textColor,
    '--header-color': '#8f8d8e',
    '--background-color': '#1d1f1f',
    '--separator-color': '#2b2b2b',
    '--button-background': _vm.button.bgColor,
    '--button-outline': _vm.button.outlineColor,
    '--button-hover': _vm.button.hoverColor,
    '--button-text': _vm.button.textColor,
    '--input-text': _vm.input.textColor,
    '--input-bg': _vm.input.bgColor,
    '--input-border': _vm.input.borderColor,
    '--input-panelBorderColor': _vm.input.panelBorderColor,
    '--input-borderRadius': _vm.input.borderRadius,
    '--scrollbar-bgColor': _vm.scrollbar.bgColor,
    '--scrollbar-handleColor': _vm.scrollbar.handleColor,
    '--scrollbar-borderRadius': _vm.scrollbar.borderRadius,
    '--headerLogo-position': _vm.accessConfig.headerLogoPosition,
    '--login-bg': _vm.accessConfig.loginView.bg,
    '--login-bg1': _vm.accessConfig.loginView.bg1,
    '--login-bg2': _vm.accessConfig.loginView.bg2,
    '--feedSocial-bgColor': _vm.feedSocial.postColor,
    '--feedSocial-borderRadius': _vm.feedSocial.borderRadius,
    '--feedSocial-subColor': _vm.feedSocial.subColor,
    '--feedSocial-textColor': _vm.feedSocial.textColor,
    '--feedSocial-postButtonBgColor': _vm.feedSocial.postButtonBgColor,
    '--feedSocial-postButtonTextColor': _vm.feedSocial.postButtonTextColor,
    '--feedSocial-postInputOutlineColor': _vm.feedSocial.postInputOutlineColor,
    '--live-bgColor': _vm.live.bgColor,
    '--live-itemColor': _vm.live.itemColor,
    '--live-textColor': _vm.live.textColor,
    '--live-borderRadius': _vm.live.borderRadius,
    '--live-borderColor': _vm.live.borderColor,
    '--userProfile-topBgColor': _vm.userProfile.topBgColor,
    '--userProfile-buttonBgColor': _vm.userProfile.buttonBgColor,
    '--userProfile-textColor': _vm.userProfile.textColor,
    '--userProfile-buttonTextColor': _vm.userProfile.buttonTextColor,
    '--userProfile-middleBgColor': _vm.userProfile.middleBgColor,
    '--userProfile-bottomBgColor': _vm.userProfile.bottomBgColor,
    '--userProfile-textFontSize': _vm.userProfile.textFontSize,
    '--userProfile-borderRadius': _vm.userProfile.borderRadius,
    '--chat-headerColor': _vm.chat.headerColor,
    '--chat-mainColor': _vm.chat.mainColor,
    '--chat-bgColor': _vm.chat.bgColor,
    '--chat-pinnedBGColor': _vm.chat.pinnedBGColor,
    '--chat-pinnedNameColor': _vm.chat.pinnedNameColor,
    '--chat-pinnedTextColor': _vm.chat.pinnedTextColor,
    '--chat-outlineColor': _vm.chat.outlineColor,
    '--chat-nameColor': _vm.chat.nameColor,
    '--chat-adminNameColor': _vm.chat.adminNameColor,
    '--chat-adminBoxColor': _vm.chat.adminBoxColor,
    '--chat-nameBoxColor': _vm.chat.nameBoxColor,
    '--chat-boxColor': _vm.chat.boxColor,
    '--chat-textColor': _vm.chat.textColor,
    '--chat-inputTextColor': _vm.chat.inputTextColor,
    '--chat-inputBGColor': _vm.chat.inputBGColor,
    '--chat-inputOutlineColor': _vm.chat.inputOutlineColor,
    '--chat-sendTextColor': _vm.chat.sendTextColor,
    '--chat-sendBGColor': _vm.chat.sendBGColor,
    '--chat-sendOutlineColor': _vm.chat.sendOutlineColor,
    '--chat-messagesOutlineColor': _vm.chat.messagesOutlineColor,
    '--chat-scrollbarBGColor': _vm.chat.scrollbarBGColor,
    '--chat-scrollbarHandleColor': _vm.chat.scrollbarHandleColor,
    '--chat-borderRadius': _vm.chat.borderRadius,
    '--chat-editBtnColor': _vm.chat.editBtnColor,
    '--chat-editBtnBGColor': _vm.chat.editBtnBGColor,
  }),attrs:{"id":"app"}},[(_vm.showJitsiMeeting && _vm.jitsiRoomID)?_c('JitsiMeeting',{ref:"jitsiMeeting",attrs:{"roomID":_vm.jitsiRoomID,"roomName":_vm.jitsiRoomName},on:{"videoConferenceLeft":_vm.deleteTakenMetaPosition}}):_vm._e(),_c('transition',{attrs:{"appear":"","name":"fade","mode":"in-out"}},[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.showNetworkWidget)?_c('NetworkWidget'):_vm._e(),_c('modals-container',{attrs:{"name":"modals-container"}}),_c('v-dialog',{attrs:{"clickToClose":false}}),(_vm.showNotes)?_c('Notes',{on:{"close":function($event){_vm.showNotes = false}}}):_vm._e(),(_vm.useSupportBox)?_c('UserSupportBox'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }